export default "__VITE_ASSET__0844cd44__"